import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { addMultiplePatients } from '@/services/authService';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const AgendaCitaAgregarFamiliar = props => {
  const { open, onClose, changeDoctorFilter, selectedDoctor } = props;
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getUserEmail = () => {
    try {
      const authData = localStorage.getItem('auth_data');
      const userData = localStorage.getItem('user');

      let email = null;
      let id = null;

      if (authData) {
        const parsed = JSON.parse(authData);
        email = parsed.paciente?.email || email;
        id = parsed.user?.id || id;
      }

      if (userData) {
        const parsedUser = JSON.parse(userData);
        email = parsedUser?.email || email;
        id = parsedUser?.id || id;
      }

      return { email, id };
    } catch (err) {
      console.error('Error parsing localStorage user data:', err);
      return { email: null, id: null };
    }
  };

  const formik = useFormik({
    initialValues: {
      apellidoPaterno: '',
      apellidoMaterno: '',
      nombres: '',
      email: '',
      telefono: '',
      tipoDocumento: 'DNI',
      documento: '',
      aceptaPoliticas: false,
      aceptaOfertas: false,
    },

    onSubmit: async values => {
      if (
        !values.apellidoPaterno ||
        !values.apellidoMaterno ||
        !values.nombres ||
        !values.email ||
        !values.telefono ||
        !values.documento
      ) {
        setErrorMessage('Complete todos los campos obligatorios');
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      if (!values.aceptaPoliticas) {
        setErrorMessage(
          'Debe aceptar las políticas de privacidad para continuar.',
        );
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      const userEmail = getUserEmail();
      if (!userEmail) {
        setErrorMessage('No se pudo obtener el email del usuario logueado');
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      const payload = {
        name: values.nombres,
        email: values.email,
        dni: values.documento,
        celular: values.telefono,
        paterno: values.apellidoPaterno,
        materno: values.apellidoMaterno,
        tipo_identidad: values.tipoDocumento,
      };

      console.log('ver', payload);

      try {
        setIsSubmitting(true);
        setErrorMessage('');

        const result = await addMultiplePatients(userEmail?.email, [payload]);

        console.log('Paciente creado o actualizado:', result);
        if (result?.success) {
          setSuccessMessage('Paciente registrado correctamente');
          changeDoctorFilter(selectedDoctor);
        } else {
          setErrorMessage('Paciente no pudo registrarse correctamente');
        }

        setTimeout(() => {
          formik.resetForm();
          setSuccessMessage('');
          setIsSubmitting(false);
          onClose();
        }, 2000);
      } catch (error) {
        console.error('Error al registrar paciente:', error);
        setErrorMessage(error.message || 'No se pudo registrar el paciente');
        setTimeout(() => setErrorMessage(''), 3500);
        setIsSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (open) {
      formik.resetForm();
      setErrorMessage('');
      setSuccessMessage('');
      setIsSubmitting(false);
    }
  }, [open]);

  if (!open) return null;

  return (
    <FlexContainer
      className={'pos-fixed justify-center align-items-center'}
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <FlexContainer
        className={
          'pos-rel flex-column align-center width-600px padtb36 padlr36'
        }
        style={{
          background: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0px 5px 18px rgba(0,0,0,0.18)',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className={
            'pos-abs top20 right20 pointer width-34px height-34px align-items-center justify-center text-18 fontWhite'
          }
          style={{
            borderRadius: '50%',
            background: '#023B7A',
            fontWeight: '900',
            boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div
          className={
            'width-520px bgWhite borderrad20 padtb20 padlr12 pos-rel top16 margb20 left30'
          }
        >
          <form
            onSubmit={formik.handleSubmit}
            className="pos-rel bgWhite left60"
            style={{
              borderRadius: '10px',
              padding: '26px',
              width: '360px',
              boxShadow: '0px 4px 20px rgba(0,0,0,0.25)',
            }}
          >
            <Label className="text-center fontBlack text-16 margb4">
              Registrar Familiar
            </Label>
            <Label className="text-center text-14 fontRed100 margb14">
              *Ingresar datos del paciente.
            </Label>

            <FlexContainer
              className="justify-between margb8"
              style={{ gap: 8 }}
            >
              <input
                type="text"
                name="apellidoPaterno"
                placeholder="1er Apellido"
                value={formik.values.apellidoPaterno}
                onChange={formik.handleChange}
                style={{
                  width: '100%',
                  border: '1px solid #D0D5DD',
                  padding: '8px',
                  borderRadius: '6px',
                }}
              />
              <input
                type="text"
                name="apellidoMaterno"
                placeholder="2do Apellido"
                value={formik.values.apellidoMaterno}
                onChange={formik.handleChange}
                style={{
                  width: '100%',
                  border: '1px solid #D0D5DD',
                  padding: '8px',
                  borderRadius: '6px',
                }}
              />
            </FlexContainer>

            <FlexContainer className="flex-column justify-between">
              <input
                type="text"
                name="nombres"
                placeholder="Nombres de paciente"
                value={formik.values.nombres}
                onChange={formik.handleChange}
                style={{
                  maxWidth: '342px',
                  border: '1px solid #D0D5DD',
                  padding: '8px',
                  borderRadius: '6px',
                  marginBottom: 8,
                }}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                style={{
                  border: '1px solid #D0D5DD',
                  maxWidth: '342px',
                  padding: '8px',
                  borderRadius: '6px',
                  marginBottom: 8,
                }}
              />
              <input
                type="text"
                name="telefono"
                placeholder="Número de Teléfono"
                value={formik.values.telefono}
                onChange={formik.handleChange}
                maxLength="9"
                style={{
                  border: '1px solid #D0D5DD',
                  maxWidth: '342px',
                  padding: '8px',
                  borderRadius: '6px',
                  marginBottom: 8,
                }}
              />
            </FlexContainer>

            <FlexContainer
              className="justify-between margb12"
              style={{ gap: 8 }}
            >
              <select
                name="tipoDocumento"
                value={formik.values.tipoDocumento}
                onChange={formik.handleChange}
                style={{
                  width: '100%',
                  border: '1px solid #D0D5DD',
                  padding: '8px',
                  borderRadius: '6px',
                }}
              >
                <option value="D.N.I.">D.N.I.</option>
                <option value="C.E.">C.E.</option>
                <option value="PASAPORTE">PASAPORTE</option>
              </select>
              <input
                type="text"
                name="documento"
                placeholder="N° de documento"
                value={formik.values.documento}
                onChange={formik.handleChange}
                maxLength={formik.values.tipoDocumento === 'D.N.I.' ? 8 : 9}
                style={{
                  width: '100%',
                  border: '1px solid #D0D5DD',
                  padding: '8px',
                  borderRadius: '6px',
                }}
              />
            </FlexContainer>

            <FlexContainer className={'margt10 text-13 fontBlack'}>
              <input
                type="checkbox"
                name="aceptaPoliticas"
                className={'margr8'}
                checked={formik.values.aceptaPoliticas}
                onChange={formik.handleChange}
              />
              Acepto las
              <a
                href="/pdf/politicadeprivacidad.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: 4 }}
              >
                políticas de privacidad de datos
              </a>
            </FlexContainer>

            <FlexContainer className={'margt10 text-13'}>
              <label className="text-12 margb12 fontBlack">
                <input
                  type="checkbox"
                  name="aceptaOfertas"
                  checked={formik.values.aceptaOfertas}
                  onChange={formik.handleChange}
                />{' '}
                Acepto recibir
                <a
                  href="/pdf/Acep_ben_of_pu_nes_2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: 4 }}
                >
                  ofertas, publicidad y novedades (Opcional)
                </a>
              </label>
            </FlexContainer>

            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                width: '100%',
                background: isSubmitting ? '#E0E0E0' : '#ffffff',
                border: '2px solid #1E3A8A',
                color: '#1E3A8A',
                padding: '10px',
                borderRadius: '18px',
                fontWeight: 600,
                marginTop: 12,
                marginBottom: 10,
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
              }}
            >
              {isSubmitting ? 'REGISTRANDO...' : 'REGISTRAR'}
            </button>

            <button
              type="button"
              onClick={onClose}
              style={{
                width: '100%',
                background: '#023B7A',
                border: '2px solid white',
                color: 'white',
                padding: '10px',
                borderRadius: '18px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              ← REGRESAR
            </button>

            {errorMessage && (
              <div
                style={{
                  background: '#FFE5E5',
                  color: '#C62828',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  textAlign: 'center',
                  marginBottom: '6px',
                  marginTop: '12px',
                  animation: 'fadeIn 0.3s ease-in-out',
                }}
              >
                {errorMessage}
              </div>
            )}
            {successMessage && (
              <div
                style={{
                  background: '#E8F5E9',
                  color: '#2E7D32',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  textAlign: 'center',
                  marginBottom: '6px',
                  marginTop: '12px',
                  animation: 'fadeIn 0.3s ease-in-out',
                }}
              >
                {successMessage}
              </div>
            )}
          </form>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AgendaCitaAgregarFamiliar;
